import React from "react";
import classNames from "classnames";

function Label({
  children,
  optional,
  className,
  ...props
}: {
  children: React.ReactNode;
  className?: string;
  optional?: boolean;
} & React.LabelHTMLAttributes<HTMLLabelElement>) {
  return (
    <label
      className={classNames(
        "block uppercase tracking-wide text-xs font-bold mb-2",
        className
      )}
      {...props}
    >
      {children}
      {optional && (
        <span className="text-gray-500 font-light dark:text-wosm-200">
          {" "}
          (opcional)
        </span>
      )}
    </label>
  );
}

export default Label;
